require('./widget_bootstrap');
require('./translations');
require('./filters');
require('./window');

import store from './store'
import { getGoogleCID, getGoogleSessionId, getFbp, getFbc, getGclid, saveMarketingId, getMarketingId } from './helpers'

const files = require.context('./vue/app/components', true, /\.vue$/i);
files.keys().map(key =>
    Vue.component(key.split('/').pop().split('.')[0], files(key).default)
);

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

import VueRouter from 'vue-router'
Vue.use(VueRouter)

import panZoom from 'vue-panzoom'
Vue.use(panZoom)

import OtpInput from "@bachdgvn/vue-otp-input"
Vue.component("v-otp-input", OtpInput)

import WidgetInit from './vue/app/components/WidgetInit'
import Event from './vue/app/components/Event'
import Timetable from './vue/app/components/Timetable'
import Checkout from './vue/app/components/Checkout'
import TestPage from './vue/app/components/TestPage'

const routes = [
    // { path: '/', redirect: '/dashboard' },
    { path: '/', name: 'widgetinit', component: WidgetInit },
    { path: '/test', name: 'checkout', component: TestPage },
    { path: '/:eventid', name: 'event', component: Event },
    { path: '/:eventid/:timetableid', name: 'timetable', component: Timetable },
    { path: '/order/:id/:hash', name: 'checkout', component: Checkout },
]

const router = new VueRouter({
    // mode: 'history',
    routes,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});

// router.beforeEach((to, from, next) => {
//     next()
// })

const load = () => {
    new Vue({
        el: '#vue-event',
        router,
        store,
        mounted() {
            if(this.$route.query && this.$route.query.testMode) {
                this.$store.commit('setTestMode', true)
            }
        }
    });
}

const arr = window.location.href.split('&');
let tkn = arr.find(x => x.includes('tkn='))
let tknLogout = arr.find(x => x.includes('tkn_logout='))
if(tkn) {
    tkn = tkn.replace('tkn=', '')
    window.localStorage.setItem('btoken', tkn);
    window.axios.defaults.headers.common['Authorization'] = 'Bearer '+tkn;
}
if(tknLogout) {
    window.localStorage.removeItem('btoken');
    window.axios.defaults.headers.common['Authorization'] = '';
}
let showId = arr.find(x => x.includes('show_id='))
if(showId) showId = showId.replace('show_id=', '')

const extractUrlParam = (name) => {
    const found = arr.find(x => x.includes(name+'='))
    if(!found) return ''
    return decodeURIComponent(found.split(name+'=')[1] || '')
}

// captured from the launcher (topbilet_iframe.js) when present; otherwise fall back to
// whatever was saved on an earlier launch, or finally to cookies set directly on this domain
// (relevant when the widget is opened directly, without going through the launcher)
saveMarketingId('fbp', extractUrlParam('fbp') || getMarketingId('fbp') || getFbp())
saveMarketingId('fbc', extractUrlParam('fbc') || getMarketingId('fbc') || getFbc())
saveMarketingId('gaClientId', extractUrlParam('gaClientId') || getMarketingId('gaClientId') || getGoogleCID())
saveMarketingId('gaSessionId', extractUrlParam('gaSessionId') || getMarketingId('gaSessionId') || getGoogleSessionId())
saveMarketingId('utmSource', extractUrlParam('utmSource') || getMarketingId('utmSource'))
saveMarketingId('utmMedium', extractUrlParam('utmMedium') || getMarketingId('utmMedium'))
saveMarketingId('utmCampaign', extractUrlParam('utmCampaign') || getMarketingId('utmCampaign'))
saveMarketingId('utmContent', extractUrlParam('utmContent') || getMarketingId('utmContent'))
saveMarketingId('utmTerm', extractUrlParam('utmTerm') || getMarketingId('utmTerm'))
saveMarketingId('gclid', extractUrlParam('gclid') || getMarketingId('gclid') || getGclid())

store.dispatch('getSettings', { showId }).then(() => {
    load()
})
